<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('note_create.title') }}</h1>
      <note-form :colony="colony" :apiary="apiary"></note-form>
    </b-container>
  </div>
</template>

<script>
import NoteForm from '../components/NoteForm'
export default {
  name: 'NoteCreate',
  props: ['apiary', 'colony'],
  components: { NoteForm }
}
</script>

<style scoped>

</style>
